const reducer = (state: WtrState) => ({
  ...state,
  isPostcodeInvalid: true,
});

export default reducer;
